(() => {
  const initializeSenixSummerHero = (root) => {
    if (!root || root.dataset.senixSummerInitialized === 'true') return;
    root.dataset.senixSummerInitialized = 'true';
    const wraps = [...root.querySelectorAll('[data-senix-summer-hotspot-wrap]')];
    const closeAll = (exception) => wraps.forEach((wrap) => {
      if (wrap === exception) return;
      wrap.classList.remove('senix-summer-hero__hotspot-wrap--open');
      wrap.querySelector('[data-senix-summer-hotspot]')?.setAttribute('aria-expanded', 'false');
    });
    wraps.forEach((wrap) => {
      const button = wrap.querySelector('[data-senix-summer-hotspot]');
      if (!button) return;
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const willOpen = !wrap.classList.contains('senix-summer-hero__hotspot-wrap--open');
        closeAll(wrap);
        wrap.classList.toggle('senix-summer-hero__hotspot-wrap--open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
      wrap.addEventListener('mouseenter', () => button.setAttribute('aria-expanded', 'true'));
      wrap.addEventListener('mouseleave', () => {
        if (!wrap.classList.contains('senix-summer-hero__hotspot-wrap--open')) button.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', () => closeAll());
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); });
  };
  document.querySelectorAll('[data-senix-summer-hero]').forEach(initializeSenixSummerHero);
  document.addEventListener('shopify:section:load', (event) => initializeSenixSummerHero(event.target.querySelector('[data-senix-summer-hero]')));
})();

